import { ApiConstants } from "../../constants/ApiConstants";
import { FORGETPASSWORD, LOGIN, REGISTER, RESENDOTP, RESETPASSWORD, VERIFYOTP } from "../Constants/AuthContants";
import { CMS_PAGE, FAQ_GET, FAQ_GET_APP } from "../Constants/CmsPageConstants";
import { createPostDataAction } from "./CommonAction";



export const CmsPageAction = (payload: any) => createPostDataAction(CMS_PAGE, ApiConstants?.CmsPage, payload, false);
export const FAQAction = (payload: any) => createPostDataAction(FAQ_GET, ApiConstants?.FaqGet, payload, false);
export const AppFAQAction = (payload: any) => createPostDataAction(FAQ_GET_APP, ApiConstants?.AppFaqGet, payload, false);